function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React, { Suspense } from "react";
import styled from "styled-components";
import { Route, Switch } from "react-router-dom";
import { withContext } from "../wr-context";
import Progress from "../progress";
import ErrorBoundary from "../error-boundary";
import i18n from "../../utils/i18n";
var RouteWithSubRoutes = function(route) {
    return /*#__PURE__*/ React.createElement(Route, {
        path: route.path,
        exact: route.exact,
        render: function(props) {
            return /*#__PURE__*/ React.createElement(route.component, _extends({}, props, {
                routes: route.routes
            }));
        }
    });
};
var Content = styled.div(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.components.content;
});
var Router = withContext(function(param) {
    var context = param.context;
    return /*#__PURE__*/ React.createElement(Content, {
        className: "content-wrapper"
    }, /*#__PURE__*/ React.createElement(ErrorBoundary, {
        message: i18n("generic.topLevelErrorBoundary")
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(Progress, null)
    }, /*#__PURE__*/ React.createElement(Switch, null, context.routes.map(function(route) {
        return /*#__PURE__*/ React.createElement(RouteWithSubRoutes, _extends({}, route));
    })))));
});
export default Router;
